import React from "react";
import { useTranslation } from "react-i18next";
import { Button as AntButton } from "antd";
import styled from "styled-components/macro";

import ModalOriginal from "components/Modal";
import { DialogWrapper } from "components/containers";
import { TitleH3 } from "components/generic";

const Modal = styled(ModalOriginal)`
  & > section {
    background: white;

    @media ${({ theme }) => theme.media.tablet} {
      width: 90%;
    }

    @media ${({ theme }) => theme.media.phone} {
      width: 90%;
    }
  }
`;

const Footer = styled.div`
  display: flex;
  gap: 24px;

  @media ${({ theme }) => theme.media.phone} {
    gap: 10px;
  }
`;

export const PlanedIntakeInsuranceModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const { t } = useTranslation("wizard");

  const handleContinue = () => {
    const continueButton = document.getElementById("PlanIntakeContinueButton");
    if (continueButton) continueButton.click();
  };

  return (
    <Modal handleClose={onClose} isShow={true}>
      <DialogWrapper>
        <TitleH3 color="hardGray" m="16px 0" fontSize="sizeSubTitle">
          {t("confirmIntakeInsurance")}
        </TitleH3>
        <Footer>
          <AntButton type="default" onClick={handleContinue} size="large">
            {t("continueAnyway")}
          </AntButton>
          <AntButton type="primary" onClick={onClose} size="large">
            {t("buttonBack")}
          </AntButton>
        </Footer>
      </DialogWrapper>
    </Modal>
  );
};
